export default __webpack_public_path__ + "static/redbull-8f298f49ecff8b2a9447087bc0e3644d.png";